// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1656060152447
      var cssReload = require("/codebuild/output/src966473678/src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  